var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	837: {
		fallback: () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(125)]).then(() => (() => (__webpack_require__(2124))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "4.0.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vuex",
	},
	3834: {
		fallback: () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(1021))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^3.5.2",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-axios",
	},
	4372: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(5031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.2.29",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	5749: {
		fallback: () => (__webpack_require__.e(69).then(() => (() => (__webpack_require__(7069))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "1.20.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "axios",
	},
	5902: {
		fallback: () => (Promise.all([__webpack_require__.e(965), __webpack_require__.e(458)]).then(() => (() => (__webpack_require__(4965))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^4.4.5",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "vue-router",
	},
	8061: {
		fallback: () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(3667))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.5.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/auth",
	},
	8389: {
		fallback: () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(1036))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^1.3.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "@shipbob/telemetry",
	},
	4458: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(5031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.5.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	},
	4125: {
		fallback: () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(5031))))),
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "^3.0.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "vue",
	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"125": [
		4125
	],
	"348": [
		837,
		3834,
		4372,
		5749,
		5902,
		8061,
		8389
	],
	"458": [
		4458
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}